import {EagColumnState} from '../types/EagColumnState';

export type SortModelEntry = {columnKey: string; order: 'ASC' | 'DESC'};

/**
 * Derives the sort model array from the current column states.
 *
 * Only columns with a non-null sort value are included.
 * Pure utility — no React, no store access. Pass store.getState().columnStates
 * at call time to avoid stale-closure bugs.
 */
export const getSortModel = (columnStates: EagColumnState[]): SortModelEntry[] =>
  columnStates
    .filter((cs): cs is EagColumnState & {sort: 'ASC' | 'DESC'} => cs.sort != null)
    .toSorted((a, b) => (a.sortIndex ?? Infinity) - (b.sortIndex ?? Infinity))
    .map((cs) => ({columnKey: cs.key, order: cs.sort}));
